export default __webpack_public_path__ + "static/media/JoungoulBell.7964b796.mp3";